import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { configureAnalytics } from './analytics/analytics';
import { createCloudflareAnalyticsClient } from './analytics/cloudflareClient';
import { ErrorBoundary } from './components/ErrorBoundary';
import './styles/global.css';
import './styles/seo.css';
import './styles/decision.css';
import './styles/radar.css';
import './styles/suite.css';
import './styles/inbox.css';
import './styles/audit-fixes.css';
import './styles/market-radar.css';
import './styles/action-ux.css';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element was not found.');
}

configureAnalytics(createCloudflareAnalyticsClient());

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
